import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import "./AdminEmailsLayout.css";

// Wraps /admin/emails (Compose) and /admin/emails/archive (Sent Emails) —
// real routes rather than internal component state, so each is
// bookmarkable/deep-linkable and the browser back button behaves normally
// between them. `end` on the Compose link keeps it from matching when the
// path is actually /admin/emails/archive.
export default function AdminEmailsLayout() {
  return (
    <div className="ael-page">
      <div className="ael-header">
        <div>
          <h1 className="ael-title">Email</h1>
          <p className="ael-sub">Compose a message for a filtered group, or search everything ever sent.</p>
        </div>
        <nav className="ael-tabs">
          <NavLink
            to="/admin/emails"
            end
            className={({ isActive }) => `ael-tab ${isActive ? "ael-tab--active" : ""}`}
          >
            Compose
          </NavLink>
          <NavLink
            to="/admin/emails/archive"
            className={({ isActive }) => `ael-tab ${isActive ? "ael-tab--active" : ""}`}
          >
            Sent Emails
          </NavLink>
        </nav>
      </div>

      <Outlet />
    </div>
  );
}